var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmartYards = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M19.3 12.4h-7.9l-2.9-3H3.3c-.2 0-.3-.2-.3-.3s.2-.3.3-.3h5.5l2.8 2.9h7.6c.2 0 .3.2.3.3s0 .4-.2.4M7.8 14h-7c-.2 0-.3-.2-.3-.3s.2-.3.3-.3h7c.2 0 .3.2.3.3s-.1.3-.3.3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M23.8 14h1.3v.7h-1.3zM25.2 12.4h-3.5V8.7h.7v3h2.8zM6 18.7c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6 1.6.7 1.6 1.6-.8 1.6-1.6 1.6m0-2.4c-.5 0-.9.4-.9.9s.4.8.9.8.9-.4.9-.9-.4-.8-.9-.8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8.6 18.7c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6 1.6.7 1.6 1.6-.7 1.6-1.6 1.6m0-2.4c-.5 0-.9.4-.9.9s.5.8.9.8.9-.4.9-.9-.4-.8-.9-.8M21.8 18.7c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6 1.6.7 1.6 1.6-.7 1.6-1.6 1.6m0-2.4c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9M3.3 12.4c-.2 0-.3-.2-.3-.3V7.3h14.9l1.7 1.1c.2.1.2.3.1.5s-.3.2-.5.1l-1.5-1h-14v4c-.1.2-.3.4-.4.4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.8 17.8h-7.1l-.1-.2c-.3-.8-1.2-1.3-1.4-1.4H3.1c-.2 0-.3-.2-.3-.3s.2-.3.3-.3h16.4zm-6.6-.7h6.1l.3-.9h-7.1c.2.2.5.5.7.9"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.5 16.2h-6.6V8.4h5.4l1.2 3.2zm-5.9-.7h5.2v-3.9l-1-2.5h-4.2zM18.8 16.4h1.7v.7h-1.7z"
})));
export default SvgSmartYards;